<template>

	<div class="col-12 override-padding">

        <div class="org_details">
          <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" >
          <b-link v-b-toggle="'organization'" >
            <div>
              ORGANIZATION
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </b-link>
          </div>
          <b-collapse v-bind:id="'organization'" class="mt-2" visible >
          <div class="border-content float-left col-12 override-padding">
          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Lookup Type:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="lookup_type" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="lookup_type"
                    :options="lookup_type_options"
                    v-on:change="getAccountType()"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Country:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                  <b-form-select 
                    name="org_country" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_country"
                    :options="country_options"
                    v-on:change="getStateLists(org_country)">
                    </b-form-select>
                </div>
                <div class="col-md-2 float-left override-padding">
                  <button
                    v-on:click="updateCountryUS()"
                    class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="margin-top: 2px"
                    >US</button>
              </div>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Market Area:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_market_area" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_market_area"
                    :options="market_area_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Status:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_status" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_status"
                    :options="org_status_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>

          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Account Type:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="account_type" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="account_type"
                    :options="account_type_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >State:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_state" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_state"
                    :options="state_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >NAICS ID:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="naics_id" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="naics_id"
                    :options="naics_id_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Updated By:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="updated_by" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="updated_by"
                    :options="user_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>


          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Program:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="program" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="program"
                    :options="program_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Zip:</label>
              </div>
              <div class="col-8 float-left override-padding">
                    <input
                      type="text"
                      name="org_zip"
                      id="org_zip"
                      class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                      v-model="org_zip"
                      maxlength="250" style="height: 38px;">

              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >NAICS #(5 digit):</label>
              </div>
              <div class="col-8 float-left override-padding">
              	  <div class="col-12 col-md-12 override-padding">
                  	<div class="col-md-8 float-left padding-lr-5" style="padding-left: 0">
	                  <input
	                    type="text"
	                    name="naics_code"
	                    id="naics_code"
	                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
	                    v-model="naics_code"
	                    maxlength="250" style="height: 38px;">
                    </div>
                  	<div class="col-md-4 float-left override-padding">
	                	<button
	                      v-on:click="naicsListModal"
	                      class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="height: 38px;"
	                      >NAICS</button>
                    </div>
                  </div>

              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Affilifate:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="affiliate" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="affiliate"
                    :options="affiliate_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>

          </div>
          </b-collapse>
          </div>

          <div style="clear: both; float: none;" class="col-12"></div>              
        <div class="org_details" style="margin-top: 30px;">

          <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" >
          <b-link v-b-toggle="'individual'" >
            <div>
              INDIVIDUAL
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </b-link>
          </div>
          <b-collapse v-bind:id="'individual'" class="mt-2" visible >
          <div class="border-content float-left col-12 override-padding">

          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Country:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                  <b-form-select 
                    name="ind_country" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="ind_country"
                    :options="country_options"
                    v-on:change="getIndStateLists(ind_country)">
                    </b-form-select>
                </div>
                <div class="col-md-2 float-left override-padding">
                  <button
                    v-on:click="updateIndCountryUS()"
                    class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="margin-top: 2px"
                    >US</button>
              </div>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Status:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="ind_status" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="ind_status"
                    :options="ind_status_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>
          </div>

          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >State:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="ind_state" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="ind_state"
                    :options="ind_state_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Title:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="title" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="title"
                    :options="title_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>

          </div>


          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Zip:</label>
              </div>
              <div class="col-8 float-left override-padding">
                    <input
                      type="text"
                      name="ind_zip"
                      id="ind_zip"
                      class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                      v-model="ind_zip"
                      maxlength="250" style="height: 38px;">

              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>
            <div class="col-12" v-if="type == 'Contact'">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Roles:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="roles" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="roles"
                    :options="roles_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              

            </div>
          </div>

          </div>
          </b-collapse>

        </div>

	    <NaicsList :isModalVisible="isNaicsModalVisible" @close="isNaicsModalVisible = false">
	      <div slot="header" class="sub-heading">
	      </div>
	      <div slot="body">
	      </div>
	      <div slot="footer" class="col-3 override-padding">
	      </div>
	    </NaicsList>

    </div>


</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import NaicsList from './../account_lookup_naics_list.vue';

export default {
        props: ['type'],
        data() {
          return {
            lookup_type: '',
            lookup_type_options: [
              { value: '', text: '-Any-' },
              { value: 'Account', text: 'Account' },
              { value: 'Enterprise', text: 'Enterprise' },
            ],
            account_type: '',
            account_type_options: [
              { value: '', text: '-Any-' },
            ],
            org_country: '',
            ind_country: '',
            org_state: '',
            ind_state: '',
            org_market_area: '',
            market_area_options: [
              { value: '', text: '-Any-' },
            ],
            country_options: [],
            state_options: [
              { value: '', text: '-Any-' },
            ],
            ind_state_options: [
              { value: '', text: '-Any-' },
            ],
            program: '',
            program_options: [
              { value: '', text: '-Any-' },
              { value: 'Mentorship', text: 'Mentorship' },
              { value: 'Apprenticeship', text: 'Apprenticeship' },
              { value: 'Mentorship & Apprenticeship', text: 'Mentorship & Apprenticeship' },
            ],
            org_status: '',
            org_status_options: [
              { value: '', text: '-Any-' },
              { value: 'Prospect', text: 'Prospect' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
              { value: 'Delete', text: 'Deleted' },
            ],
            affiliate_options: [],
            affiliate: '',
            updated_by: '',
            user_options: [],
            ind_status: '',
            ind_status_options: [
              { value: '', text: '-Any-' },
              { value: 'Prospect', text: 'Prospect' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
            ],
            title: '',
            title_options:  [
              {value: '', text: '-Any-'},
              {value: 'Associate Publisher', text: 'Associate Publisher'},
              {value: 'CEO', text: 'CEO'},
              {value: 'Collision Center Manager', text: 'Collision Center Manager'},
              {value: 'Content Director', text: 'Content Director'},
              {value: 'COO', text: 'COO'},
              {value: 'Director of Operations', text: 'Director of Operations'},
              {value: 'Editor', text: 'Editor'},
              {value: 'Editorial Director', text: 'Editorial Director'},
              {value: 'Executive Manager', text: 'Executive Manager'},
              {value: 'Fixed Operations Director', text: 'Fixed Operations Director'},
              {value: 'Fixed Operations Manager', text: 'Fixed Operations Manager'},
              {value: 'Front Office', text: 'Front Office'},
              {value: 'General Manager', text: 'General Manager'},
              {value: 'General Sales Manager', text: 'General Sales Manager'},
              {value: 'Group Publisher', text: 'Group Publisher'},
              {value: 'HR Director', text: 'HR Director'},
              {value: 'Managing Partner', text: 'Managing Partner'},
              {value: 'Owner/DP', text: 'Owner/DP'},
              {value: 'President', text: 'President'},
              {value: 'Service Advisor', text: 'Service Advisor'},
              {value: 'Service Manager', text: 'Service Manager'},
              {value: 'Service Operations Manager', text: 'Service Operations Manager'},
              {value: 'Technician', text: 'Technician'},
              {value: 'Vice President', text: 'Vice President'}, 
              {value: 'Prospect', text: 'Prospect' },
            ],
            roles: '',
            roles_options: [
              { value: '', text: '-Any-' },
              { value: 'Manager', text: 'Manager' },
              { value: 'Mentor', text: 'Mentor' },
              { value: 'Billing Admin', text: 'Billing Admin' },
              { value: 'News Admin', text: 'News Admin' },
            ],
            naics_id: '',
            naics_id_options: [], 
            org_zip: '',
            ind_zip: '',
            naics_code: '',
            isNaicsModalVisible: false,
          }
        },
        components: {
        	NaicsList,
        },
        methods: {
          getAccountType: function() {
          	if(this.lookup_type == 'Account') {
          		this.account_type = '';
          		this.account_type_options = [
          			{ value: '', text: '-Any-' },
          			{ value: 'Company', text: 'Company' },
          			{ value: 'School', text: 'School' },
      			];
          	} else if(this.lookup_type == 'Enterprise') {
          		this.account_type = '';
          		this.account_type_options = [
        			{ value: '', text: '-Any-' },
		            { value: 'Manage', text: 'Manage' },
		            { value: 'Readonly', text: 'Read Only' },
      			];
          	} else {
          		this.account_type = '';
          		this.account_type_options = [
          			{ value: '', text: '-Any-' },
      			];
          	}
          },
          closeModal() {
            this.$emit('close');
          },
          naicsListModal: function() {
            this.isNaicsModalVisible = true;
          },
          naicsValuesAction: function(naicslist) {
            this.naics_id = naicslist.naicsId;
            this.naics_code = naicslist.naicsCode.toString();
            this.isNaicsModalVisible = false;
          },
          getCountryLists: function () {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
              this.country_options = response.data;
              this.country_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          getMarketAreaLists: function () {
            axios.get('/get-market-area-lists', {

            })
            .then(response =>  {
              this.market_area_options = response.data;
              this.market_area_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          getStateLists: function (CountryCode) {
            this.org_state = [];
            this.org_state = '';
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
              this.state_options = response.data;
              this.state_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          updateCountryUS: function() {
            this.org_country = 'US';
            this.getStateLists(this.org_country);
          },
          getIndStateLists: function (CountryCode) {
            this.ind_state = [];
            this.ind_state = '';
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
              this.ind_state_options = response.data;
              this.ind_state_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          updateIndCountryUS: function() {
            this.ind_country = 'US';
            this.getIndStateLists(this.ind_country);
          },
           fetchUserOptions: function() {
             axios.get('/masteradmin-researcher-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: '-Any-'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                  var affiliate_option = {value: '', text: '-Any-'};
                  this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
        },
        created() {
          this.getCountryLists();
          this.getMarketAreaLists();
          this.fetchAffiliateOptions();
          this.fetchUserOptions();
          axios('/naicsids',
           {
              method: 'GET',
           },
          )
          .then(response => {
              this.naics_id_options.push({value: '', text: '-Any-'});
              for(var i=0; i < response.data.length; i++) {
                var naicsIdOption = {value: response.data[i].id, text: response.data[i].title};
                this.naics_id_options.push(naicsIdOption);
              }
           })
          .catch(error => {

          });





        },

    }

</script>
<style scoped>
@import '../../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}
.account_view_list_heading_row {
  background: none;
}
  label {
    padding-top: 8px;
  }
  .border-content {
    border: 1px solid #CCC;
    padding-top: 10px;
    border-top: 0;
  }
  .display_column_heading {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 20px;
    margin-top: 2px;
    color: #FFF;
  }
  .collapse-wrapper {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 10px;
    margin-top: 2px;
  }
  .collapse-wrapper a, .collapse-wrapper a:hover{ 
    color: #FFF;
    text-decoration: none;
    padding-top: 5px;
    display: inherit;
  }
  .collapse-wrapper i {
    float: right;
    font-size: 18px;
    font-weight: bold;
    padding-top: 0px;
    color: #FFF;
  }

tr th {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
tr td {
  color: #212529;
}
.account-lookup-view-list .field_title {
    width: auto;
    border-right: 1px solid #b6b6b6;
    padding-left: 5px;
    padding-right: 5px;
}
.view-lists {
  width: 100%;
}
.custom-select {
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/account_report_filter.vue